import {
  AnalyticsEventParam,
  convertDateToString,
  MediaSubtype,
} from '@accedo/one-plugin-sdk';

import { Item } from '#/client/models';
import { isAudio } from '#/hooks/playback/utils';

/**
 * Creates item scoped analytics payload.
 * @returns a payload based on the AnalyticsItemParams from the one-plugin-sdk.
 */
export const createItemPayload = (item?: Item) => {
  if (!item) {
    return {};
  }

  // some properties are not yet implemented, have a temporary customer-specific implementation, or other issue.
  // see the comments below.

  const releaseDate = item.releaseDate
    ? convertDateToString(new Date(item.releaseDate))
    : undefined;

  const audioOrVideo = isAudio(item) ? item.audio : item.video;

  return {
    // for current response - customer independent solution needed
    [AnalyticsEventParam.AirDate]: releaseDate,
    // Slight a hack: let's use item title as channelName, when it's a LIVE_CHANNEL subtype.
    // If better data is available for this purpose, it should be used instead.
    [AnalyticsEventParam.ChannelName]:
      item.subtype === MediaSubtype.LiveChannel ||
      item.subtype === MediaSubtype.LiveAudioChannel
        ? item.title
        : undefined,
    [AnalyticsEventParam.ContentId]: item.id,
    [AnalyticsEventParam.Description]: item.description,
    [AnalyticsEventParam.EpisodeNumber]: item.episode?.number,
    [AnalyticsEventParam.Extras]: item.extras,
    //[AnalyticsEventParam.FrameRate]: item.?,
    //[AnalyticsEventParam.FullEpisode]: item.?,
    [AnalyticsEventParam.Genre]: item.genres,

    // duration is `number | string` for some reason (?)
    [AnalyticsEventParam.Length]: Number(audioOrVideo?.duration ?? '0'),
    [AnalyticsEventParam.LiveStream]:
      item.subtype === MediaSubtype.LiveChannel ||
      item.subtype === MediaSubtype.LiveAudioChannel,

    // for HMN response - customer independent solution needed
    [AnalyticsEventParam.Program]: item.tvShow?.title,

    // for current response - customer independent solution needed
    [AnalyticsEventParam.PublishDate]: releaseDate,
    //[AnalyticsEventParam.Publisher]: item.?,

    // the same situation for SeasonNumber as was for PublishDate
    // for HMN response - customer independent solution needed
    [AnalyticsEventParam.SeasonNumber]: item.tvShowSeason?.season.number,
    [AnalyticsEventParam.Title]: item.title,

    // this is a duplicate, should be removed, left here for backwards compatibility for now
    // should be mapped to program, but customer independent solution needed in the long term
    [AnalyticsEventParam.TvShowTitle]: item.tvShow?.title,
    [AnalyticsEventParam.Subtype]: item.subtype,
  };
};
